import React, { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import '../../css/Admin.css'; // notre CSS dédié

const AdminStatsLandingChart = ({ globalStats, userStats }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!globalStats || !userStats) return <p>Aucune donnée disponible.</p>;

  // Préparer données landing pages anonymes (globalStats)
  const anonData = globalStats.map(g => ({
    week: new Date(g.weekStart).toLocaleDateString(),
    nbLanding: g.nbLanding || 0,
  }));

  // Préparer données landing pages connectées (userStats)
  const connectedData = Object.values(
    userStats.reduce((acc, s) => {
      const week = new Date(s.weekStart).toLocaleDateString();
      if (!acc[week]) acc[week] = { week, nbLanding: 0 };
      acc[week].nbLanding += s.nbLanding || 0;
      return acc;
    }, {})
  );

  return (
    <div className="landing-chart-panel">
      <h2
        className="landing-chart-title cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        Évolution des landing pages {isOpen ? '▼' : '▲'}
      </h2>

      {isOpen && (
        <div className="landing-chart-row">
          {/* Landing anonymes */}
          <div className="landing-chart-col">
            <h3 className="landing-chart-subtitle">Anonymes</h3>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={anonData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="anonColor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#facc15" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#facc15" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="nbLanding" stroke="#eab308" fill="url(#anonColor)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>

          {/* Landing utilisateurs connectés */}
          <div className="landing-chart-col">
            <h3 className="landing-chart-subtitle">Connectés</h3>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={connectedData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="connectedColor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#22c55e" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#22c55e" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="nbLanding" stroke="#16a34a" fill="url(#connectedColor)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStatsLandingChart;
